var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.media.genres.length > 0)?_c('v-slide-group',_vm._l((_vm.media.genres),function(genre,index){return _c('v-slide-item',{key:index},[_c('v-chip',{staticClass:"mr-2 mb-2 genre-chips",attrs:{"color":"secondary"}},[_vm._v(_vm._s(genre.name))])],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }